import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressBarIncomplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 134,
	viewBox: "0 0 400 134",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M33 50H365C374.4 50 382 57.6 382 67C382 76.4 374.4 84 365 84H33C23.6 84 16 76.4 16 67C16 57.6 23.6 50 33 50Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M211.1 53H33C25.3 53 19 59.3 19 67C19 74.7 25.3 81 33 81H211.1C217.6 81 223.4 76.4 224.8 70.1C226.3 63.4 222.5 56.4 216.1 53.9C214.5 53.3 212.8 53 211.1 53Z",
			fill: "url(#paint0_linear_93_21973)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_93_21973",
			x1: 240.346,
			y1: 41.1543,
			x2: 1.3006,
			y2: 93.3799,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: .8
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white"
			})]
		}) })
	]
});
export default SvgProgressBarIncomplete;
